import React from "react";

function EditOfferBanner() {
  return <div>EditOfferBanner</div>;
}

export default EditOfferBanner;
